import { forwardRef } from "react";

import { LinkStyled } from "./Link.styles";
import { TLinkProps, TLinkRef } from "./Link.types";

const Link = forwardRef<TLinkRef, TLinkProps>(function Link({ weight = "base", variant = "base", ...rest }, ref) {
  return (
    <LinkStyled
      ref={ref}
      $weight={weight}
      $variant={variant}
      {...rest}
    />
  );
});

export default Link;
